<template>
  <div class="bg-thankyou lg:bg-transparent bg-black/50 bg-blend-overlay flex align-bottom items-end">
    <div class="pb-20 px-4 lg:pl-16 text-left">
      <p class="font-benzin text-white text-3xl lg:text-5xl tracking-wide font-normal py-0 pb-6 my-0">THANK <span class="text-brand-primary">YOU</span></p>
      <p class="text-lg text-white font-poppins tracking-normal pt-2 py-0 my-0 max-w-lg font-normal pb-8">Your internet service set-up is now in progress. We’ll be in touch soon with the next steps to complete your activation. If you have any questions in the meantime, feel free to contact our support team.</p>
      <a href="/" type="button" class="shadow-sm transition duration-500 ease-in-out text-center items-center justify-center px-4 py-3 md:text-md rounded-full text-white bg-transparent md:text-18 md:px-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-accent border border-white border-solid font-poppins text-18 cursor-pointer hover:bg-black">
          Back to Homepage
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Title from '../components/content/Title.vue';
import Container from '../components/content/Container.vue';
import HelpOptions from '../components/content/HelpOptions.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
const contacts = brandService.getContacts();

</script>
<style scoped>

.bg-thankyou {
  background-repeat: no-repeat;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/thankyou-bg.png");
  background-position: center center;
  background-size: cover;
  height: 100vh;
}

@media only screen and (max-width: 768px) {
  .bg-thankyou {
    background-repeat: no-repeat;
    background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/thankyou-bg.png");
    background-position: 67%;
    background-size: cover;
    height: 100vh;
  }

}
</style>
